const mainPattern = /^(?<major>[0-9]+)(?:\.(?<minor>[0-9]+))?(?:\.(?<patch>[0-9]+))?/
const preReleasePattern = /-(?<preRelease>[a-z]+)(?:[.-](?<preReleaseNum>[0-9]+))?$/

export function parseVersionString(version: string): [number, number, number, string | undefined, number | undefined] {
  if (!version) throw new Error('missing input version')

  const mainMatch = version.match(mainPattern)
  if (!mainMatch || !mainMatch.groups)
    throw new Error(`invalid version "${version}" - does not match main pattern ${mainPattern}`)

  const preReleaseMatch = version.match(preReleasePattern)

  const major = Number(mainMatch.groups.major)
  const minor = mainMatch.groups.minor ? Number(mainMatch.groups.minor) : undefined
  const patch = mainMatch.groups.patch ? Number(mainMatch.groups.patch) : undefined
  const preRelease = preReleaseMatch?.groups ? preReleaseMatch.groups.preRelease : undefined
  const preReleaseNum = preReleaseMatch?.groups?.preReleaseNum
    ? Number(preReleaseMatch.groups.preReleaseNum)
    : undefined

  return [major, minor, patch, preRelease, preReleaseNum].filter((v) => v !== null && v !== undefined) as [
    number,
    number,
    number,
    string,
    number,
  ]
}

export function compareVersions(a: string, b: string): number {
  const [aMajor, aMinor, aPatch, aPre, aPreNum = 0] = parseVersionString(a)
  const [bMajor, bMinor, bPatch, bPre, bPreNum = 0] = parseVersionString(b)

  if (aMajor !== bMajor) return aMajor - bMajor
  if (aMinor !== bMinor) return aMinor - bMinor
  if (aPatch !== bPatch) return aPatch - bPatch
  if (!aPre && bPre) return 1
  if (aPre && !bPre) return -1
  if (aPre && bPre) {
    if (aPre !== bPre) return aPre.localeCompare(bPre)
    if (aPreNum !== bPreNum) return aPreNum - bPreNum
  }
  return 0
}
